import React from 'react'
import './index.scss'

export default ({ lineStyle }) => {
  return <div className="line" style={lineStyle}></div>
}
